<template>
  <v-container grid-list-xs>
    <v-card>
      <v-card-title class="d-flex align-center flex-wrap ga-2">
        <span>Ingressos</span>
        <v-spacer></v-spacer>
        <v-btn
          v-if="groupSelected"
          color="primary"
          variant="tonal"
          :to="{ name: 'TicketCheck' }"
        >
          <v-icon class="mr-1">mdi-qrcode-scan</v-icon>
          Validar ingresso
        </v-btn>
      </v-card-title>
      <v-card-text v-if="!groupSelected">Selecione um Grupo</v-card-text>
      <template v-else>
        <v-alert type="info" variant="tonal" density="compact" class="ma-3">
          Códigos emitidos após pagamento de produtos do tipo <strong>Ingresso</strong>.
          Capacidade = estoque (pool do grupo + alocação na loja).
        </v-alert>
        <v-row>
          <v-col cols="12">
            <v-form @submit.prevent="submitSearch">
              <v-expansion-panels variant="accordion" v-model="filterPanel">
                <v-expansion-panel value="searchFiltersPanel" rounded="lg">
                  <v-expansion-panel-title
                    style="color:#000000 !important; background-color: #e0e0e0ff; opacity: 1 !important"
                  >
                    <v-row style="opacity: 1 !important">
                      <v-col cols="12" md="6">
                        <span class="v-card-title">Filtro de pesquisa</span>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text class="bg-grey-lighten-2">
                    <v-row>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="filters.code"
                          label="Código"
                          clearable
                          density="compact"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-select
                          v-model="filters.status"
                          :items="statusFilterItems"
                          item-title="title"
                          item-value="value"
                          label="Status"
                          clearable
                          density="compact"
                          hide-details
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-select
                          v-model="filters.store_id"
                          :items="storeFilterItems"
                          item-title="title"
                          item-value="value"
                          label="Loja"
                          clearable
                          density="compact"
                          hide-details
                          :loading="loadingStores"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="filters.sale_id"
                          label="Venda #"
                          type="number"
                          clearable
                          density="compact"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="filters.from"
                          label="Emitido de"
                          type="date"
                          clearable
                          density="compact"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="filters.to"
                          label="Emitido até"
                          type="date"
                          clearable
                          density="compact"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-select
                          :items="[25, 50, 100]"
                          v-model="filters.itemsPerPage"
                          label="Por página"
                          density="compact"
                          hide-details
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-btn color="warning" @click="clearFilters">
                        <v-icon class="mr-2">mdi-broom</v-icon>
                        Limpar
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" type="submit" :loading="loading">
                        <v-icon class="mr-2">mdi-magnify</v-icon>
                        Pesquisar
                      </v-btn>
                    </v-card-actions>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-form>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="tickets"
              :loading="loading"
              :items-per-page="filters.itemsPerPage"
              return-object
              class="elevation-1"
              hide-default-footer
            >
              <template v-slot:bottom>
                <div class="text-center pt-2">
                  <v-pagination
                    :disabled="loading"
                    v-model="page"
                    :length="maxPage"
                  ></v-pagination>
                </div>
              </template>
              <template v-slot:item.code="{ value }">
                <code class="text-body-2">{{ value }}</code>
              </template>
              <template v-slot:item.status="{ value }">
                <v-chip size="small" variant="tonal" :color="statusColor(value)">
                  {{ statusLabel(value) }}
                </v-chip>
              </template>
              <template v-slot:item.scans="{ item }">
                <span>{{ item.scan_count ?? 0 }}/{{ item.max_scans ?? 1 }}</span>
              </template>
              <template v-slot:item.issued_at="{ value }">
                <span>{{ formatDateTime(value) }}</span>
              </template>
              <template v-slot:item.used_at="{ value }">
                <span>{{ formatDateTime(value) }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-if="item.sale_id"
                  size="small"
                  variant="text"
                  color="primary"
                  @click="openSale(item.sale_id)"
                >
                  Venda
                </v-btn>
              </template>
              <template v-slot:no-data>
                <div class="text-center text-medium-emphasis py-6">
                  Nenhum ingresso encontrado
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </template>
    </v-card>

    <DialogSaleDetail
      v-model="saleDetailModel"
      :canRefundSales="true"
      @refunded="onSaleRefunded"
    />
  </v-container>
</template>
<script>
import DialogSaleDetail from '../components/DialogSaleDetail.vue'
import api from '@/services'
import { normalizeListPayload } from '@/utils/listPayload'

const STATUS_LABELS = {
  valid: 'Válido',
  used: 'Utilizado',
  voided: 'Anulado',
}
const STATUS_COLORS = {
  valid: 'success',
  used: 'warning',
  voided: 'secondary',
}

export default {
  components: { DialogSaleDetail },
  props: {
    user: Object,
  },
  data() {
    return {
      loading: false,
      loadingStores: false,
      tickets: [],
      stores: [],
      page: 1,
      maxPage: 1,
      filterPanel: 'searchFiltersPanel',
      saleDetailModel: {},
      filters: {
        code: null,
        status: null,
        store_id: null,
        sale_id: null,
        from: null,
        to: null,
        itemsPerPage: 25,
      },
      statusFilterItems: [
        { title: 'Todos', value: null },
        { title: 'Válido', value: 'valid' },
        { title: 'Utilizado', value: 'used' },
        { title: 'Anulado', value: 'voided' },
      ],
      headers: [
        { title: 'Código', align: 'start', key: 'code', sortable: true },
        { title: 'Produto', align: 'start', key: 'product_name', sortable: true },
        { title: 'Status', align: 'start', key: 'status', sortable: true },
        { title: 'Scans', align: 'end', key: 'scans', sortable: false },
        { title: 'Venda', align: 'end', key: 'sale_id', sortable: true },
        { title: 'Loja', align: 'end', key: 'store_id', sortable: true },
        { title: 'Emitido', align: 'end', key: 'issued_at', sortable: true },
        { title: 'Usado', align: 'end', key: 'used_at', sortable: true },
        { title: 'Ações', key: 'actions', align: 'end', sortable: false },
      ],
    }
  },
  computed: {
    groupSelected() {
      return api.storage.isGroupSelected()
    },
    storeFilterItems() {
      return (this.stores || []).map((s) => ({
        title: s.name || `Loja #${s.id}`,
        value: s.id,
      }))
    },
  },
  mounted() {
    if (this.groupSelected) {
      this.loadStores()
      this.fetchList(1)
    }
  },
  activated() {
    if (this.groupSelected) {
      this.loadStores()
      this.fetchList(this.page)
    }
  },
  methods: {
    statusLabel(value) {
      return STATUS_LABELS[value] || value || '—'
    },
    statusColor(value) {
      return STATUS_COLORS[value] || 'default'
    },
    formatDateTime(value) {
      if (!value) return '—'
      if (this.$moment) {
        return this.$moment(value).format('DD/MM/YYYY HH:mm')
      }
      try {
        return new Date(value).toLocaleString('pt-BR')
      } catch {
        return value
      }
    },
    openSale(saleId) {
      if (!saleId) return
      this.saleDetailModel = { id: saleId }
    },
    onSaleRefunded() {
      this.fetchList(this.page)
    },
    clearFilters() {
      this.filters.code = null
      this.filters.status = null
      this.filters.store_id = null
      this.filters.sale_id = null
      this.filters.from = null
      this.filters.to = null
    },
    submitSearch() {
      this.fetchList(1)
    },
    loadStores() {
      const vm = this
      if (vm.loadingStores) return Promise.resolve()
      vm.loadingStores = true
      return api.store
        .list({ itemsPerPage: 200, active: true }, 1)
        .then((result) => {
          const { items } = normalizeListPayload(result)
          vm.stores = items || []
        })
        .catch(() => {
          vm.stores = []
        })
        .finally(() => {
          vm.loadingStores = false
        })
    },
    fetchList(page) {
      const vm = this
      if (!vm.groupSelected || vm.loading) return
      vm.loading = true
      vm.page = page || 1
      const payload = {
        itemsPerPage: vm.filters.itemsPerPage,
      }
      if (vm.filters.code) payload.code = String(vm.filters.code).trim()
      if (vm.filters.status) payload.status = vm.filters.status
      if (vm.filters.store_id) payload.store_id = Number(vm.filters.store_id)
      if (vm.filters.sale_id) payload.sale_id = Number(vm.filters.sale_id)
      if (vm.filters.from) payload.from = vm.filters.from
      if (vm.filters.to) {
        // end of day when only date is given
        payload.to = `${vm.filters.to} 23:59:59`
      }
      return api.ticket
        .list(payload, vm.page)
        .then((result) => {
          const { items, meta } = normalizeListPayload(result)
          vm.tickets = items || []
          if (meta) {
            vm.page = meta.current_page || vm.page
            vm.maxPage = meta.last_page || 1
          } else {
            vm.maxPage = 1
          }
          vm.filterPanel = ''
        })
        .catch((err) => {
          if (err?.message) {
            vm.$notify({ type: 'warn', text: err.message })
          }
        })
        .finally(() => {
          vm.loading = false
        })
    },
  },
  watch: {
    page(newVal, oldVal) {
      if (newVal !== oldVal && !this.loading && this.groupSelected) {
        this.fetchList(newVal)
      }
    },
  },
}
</script>
